export type EventTypes = {
  'page:change': (data: { url: string }) => void;
  'article:load': (data: { articleId: string; body: string }) => void;
};

export type OnEventType = keyof EventTypes;
type OnFunction = (event: OnEventType, cb: EventTypes[typeof event]) => void;

declare global {
  interface Window {
    kb: {
      on: OnFunction;
    };
  }
}

// This stores the callback functions
const callbacks: Partial<EventTypes> = {};

/**
 * Add the api functions to the window object.
 */
export function setup() {
  window.kb = {
    on: (event, cb) => {
      registerCallback(event, cb);
    },
  };
}

export function registerCallback<T extends OnEventType>(
  event: T,
  cb: EventTypes[T]
) {
  switch (event) {
    case 'page:change':
      callbacks[event] = cb;
      return;
    case 'article:load':
      callbacks[event] = cb;
      return;
    default: {
      const msg = `window.on: ${event} is not a supported event type.`;
      console.warn(msg);
      // TODO: TS3.5 breaks UnreachableCaseError in this case.
      // return diagnostics.warn(msg, cb);
      // assertNever(event);
      // new UnreachableCaseError(event);
    }
  }
}

type GetFunctionProperty<T> = T extends keyof EventTypes
  ? EventTypes[T]
  : never;
type GetFunctionParamType<B> = GetFunctionProperty<B> extends (
  p: infer P
) => void
  ? P
  : never;

export function triggerCallback<E extends OnEventType>(
  event: E,
  data: GetFunctionParamType<E>
) {
  const cb = callbacks[event];
  if (typeof cb === 'function') {
    // TS is complaining about this, not sure why...
    (cb as Function)(data);
  }
}
